export enum BackupDaysFilterEnum {
    EQUAL = 'Igual',
    BIGGER = 'Maior',
    SMALLER = 'Menor',
}

export type BackupDaysFilter = 'EQUAL' | 'BIGGER' | 'SMALLER';
